<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__bottom">
        <Panel :title="title" variant="success" message />
        <div class="wysiwyg" v-html="content"></div>
        <div class="soft bg__light-grey push__ends">
            <h2 class="delta push__bottom--half">Please note:</h2>
            <div class="wysiwyg" v-html="noteContent"></div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "Result",
  created() {
    localStorage.clear();
  },
  data() {
    return {
      title: "Referral Submitted",
      content: "<p>Thank you for your self referral to MSK Physiotherapy.  It will now be read by a member of our team and added to our waiting list.  If we feel it is not suitable for our service, we will inform you.</p><p>When you reach the top of our waiting list, we will send you a letter asking you to contact our booking centre to arrange an appointment that is suitable for you.</p>",
      noteContent: "<p>While you are waiting there may be things you can do to manage and improve your condition and stay as active as possible.</p><p>Please have a look on our NHS Physiotherapy website for exercises and advice, or go to NHS Inform.</p><p class='align-right'><a class='btn btn--primary' href='https://www.nhsggc.scot/hospitals-services/services-a-to-z/musculoskeletal-msk-physiotherapy/'>NHS Physiotherapy website</a></p><p class='align-right'><a class='btn btn--secondary' href='http://www.nhsinform.scot/msk'>NHS Inform</a></p>",
      notEntitledHeader: "You are not entitled to:",
      responses: [],
      userExemptions: {},
      injectionHtml: {},
      checklist: []
    };
  }
};
</script>

